import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import Modal from '../../component/Inc/Modal';
import 'contents/assets/scss/page/member.scss';

function Login() {
  const [modalAlert, setModalAlert] = useState(false);
  return (
    <main className="com_member p_login">
      <div className="box">
        <h2 className="title">EZ 수능교육</h2>
        <div className="com_input_wrap">
          <section className="sec_input">
            <input type="text" placeholder="ID(이메일 입력)" className="input" />
          </section>
          <section className="sec_input">
            <input type="text" placeholder="PW" className="input" />
          </section>
        </div>
        <p className="error_txt">
          ID 또는 PW가 정확하지 않습니다. <br />
          <span className="cnt">4</span>회 남았습니다.
        </p>
        <section className="check">
          <input type="checkbox" id="chk01" className="com_chk" />
          <label htmlFor="chk01">ID저장</label>
        </section>
        <section className="com_btn_wrap">
          <button onClick={() => setModalAlert(true)} className="com_btn m orange full bold">
            로그인
          </button>
          <Link to="/Member/SearchId" className="com_btn m lightGray">
            아이디 찾기
          </Link>
          <Link to="/Member/SearchPw" className="com_btn m lightGray">
            비밀번호 찾기
          </Link>
        </section>
      </div>
      {/* Modal */}
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <h2 className="pop_tit">알림</h2>
        <div className="content_container scroll">
          <p>
            로그인 해 주셔서 감사합니다. <br />
            아직 개인 정보 등록이 완료되지 않았습니다. <br />
            마이 페이지에서 완료해 주세요.
          </p>
        </div>
        <div className="btn_container">
          <Link to="/Mypage/Teacher" className="com_btn orange xs">
            마이페이지 이동
          </Link>
        </div>
      </Modal>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <h2 className="pop_tit">알림</h2>
        <div className="content_container scroll">
          <p>
            5회 이상 ID 또는 PW 입력오류 입니다.
            <br />
            관리자에게 문의하세요.
          </p>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default Login;
